import type {IdentifiedFile} from 'typings/portaro.be.types';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export class FileContentDataService {
    public static serviceName = 'fileContentDataService';
    public static ROUTE = 'files';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getFileContent(file: IdentifiedFile, type: 'original' | 'thumbnail' | 'text' = 'original'): Promise<string> {
        if (type === 'original') {
            return this.ajaxService.withoutBaseUrl().createRequest(`${FileContentDataService.ROUTE}/${file.id}`).get<string>();
        }
        return this.ajaxService.withoutBaseUrl().createRequest(`${FileContentDataService.ROUTE}/${file.id}/${type}`).get<string>();
    }
}